import { GET_INVOICES } from '../../endpoints';
import { Invoice } from '../../types/invoice';
import makeAuthenticatedRequest from '../base-api';

const invoicesQueryKey = ['invoices'];

const getInvoices = async ({
  invoiceFor,
  startDate,
  endDate,
  status,
  paymentStatus,
  search,
  page = 1,
  limit = 10,
  sortBy = 'billDate',
  sortOrder = 'desc',
  clientId,
  agentId,
}: {
  invoiceFor: 'client' | 'agent';
  startDate?: string;
  endDate?: string;
  status?: string;
  paymentStatus?: string;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  clientId?: string;
  agentId?: string;
}): Promise<{
  success: boolean;
  data?: {
    invoices: Invoice[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalCount: number;
      limit: number;
      hasNextPage: boolean;
      hasPrevPage: boolean;
    };
    summary: {
      totalInvoices: number;
      totalAmount: number;
      paidAmount: number;
      pendingAmount: number;
      overdueCount: number;
    };
  };
  message?: string;
}> => {
  try {
    const params = new URLSearchParams();

    params.append('for', invoiceFor);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (status) params.append('status', status);
    if (paymentStatus) params.append('paymentStatus', paymentStatus);
    if (search) params.append('search', search);
    if (clientId) params.append('clientId', clientId);
    if (agentId) params.append('agentId', agentId);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    params.append('page', String(page));
    params.append('limit', String(limit));

    const url = `${GET_INVOICES()}?${params.toString()}`; 
    const response = await makeAuthenticatedRequest(url, { method: 'GET' });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result.data;
  } catch (e) {
    console.error('Error fetching invoices:', e);
    throw e;
  }
};

export { getInvoices, invoicesQueryKey };